<!--
  Everlume Solutions — root shell.
  Header + routed page + footer. All page content lives in feature components.
-->
<app-header />

<main class="app-main">
  <router-outlet />
</main>

<app-footer />
<app-chat-widget />
<app-cookie-consent />
